import styled from 'styled-components'

export const ConversationOrderSummaryNameCellStyled = styled.div`
  min-width: 0;
`
